<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <div class="navi-hover scroll card-body p-1" [perfectScrollbar]="{ wheelPropagation: false }">
    <div class="form-group row p-5">
      <div class="col-lg-12 kt-margin-bottom-20-mobile" [formGroup]="actionForm">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" required />
          <mat-error *ngIf="isControlHasError('name', 'required')">
            {{ getErrorMessage('Name') }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-lg-12 kt-margin-bottom-20-mobile" [formGroup]="actionForm">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Type</mat-label>
          <mat-select
            [(value)]="actionType"
            formControlName="type"
            [disabled]="data.mode === 'update'"
            required
          >
            <mat-option disabled hidden>-</mat-option>
            <mat-option *ngFor="let action of actionTypesList" [value]="action">
              {{ action }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isControlHasError('type', 'required')">
            {{ getErrorMessage('Type') }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-lg-12 p-4">
        <div
          class="p-3 custom-api-container"
          *ngIf="actionType === 'CUSTOM_API'"
          [formGroup]="customAPIForm"
        >
          <label class="text-muted">Custom API Details</label>
          <kt-general-autocomplete
            [label]="'Credential'"
            [loadItemsFunction]="credentialAutocompleteCall"
            [optionFormatter]="stringUtils.filterCredentialFn"
            [valueFormatter]="stringUtils.filterCredentialFn"
            [required]="true"
            [readOnly]="false"
            [control]="credentialControl"
            [change]="onCredentialChange.bind(this)"
            [dataPath]="'data'"
            [placeholder]="'Select Credential'"
            #credentialAutocomplete
          ></kt-general-autocomplete>
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>HTTP Method</mat-label>
            <mat-select formControlName="http_method" required>
              <mat-option value="GET">
                <span class="navi-text">
                  <span class="label label-xl label-inline label-light-primary">GET</span>
                </span>
              </mat-option>
              <mat-option value="POST">
                <span class="navi-text">
                  <span class="label label-xl label-inline label-light-success">POST</span>
                </span>
              </mat-option>
              <mat-option value="PUT">
                <span class="navi-text">
                  <span class="label label-xl label-inline label-light-info">PUT</span>
                </span>
              </mat-option>
              <mat-option value="DELETE">
                <span class="navi-text">
                  <span class="label label-xl label-inline label-light-danger">DELETE</span>
                </span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('http_method', 'required')">
              {{ getErrorMessage('HTTP Method') }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>API URL</mat-label>
            <div class="row">
              <div class="col-11">
                <input
                  matInput
                  type="url"
                  formControlName="url"
                  required
                  (focusout)="showExternalLinkIcon()"
                />
              </div>
            </div>
            <mat-error *ngIf="isUrlError()">
              {{ 'AUTH.VALIDATION.PATTERN' | translate }}
            </mat-error>
            <mat-error *ngIf="isControlHasError('url', 'required')">
              {{ getErrorMessage('API URL') }}
            </mat-error>
          </mat-form-field>
          <div class="border rounded p-4">
            <div class="row">
              <div class="col-9">
                <mat-form-field appearance="outline" class="mb-5">
                  <mat-label>Payload Keys</mat-label>
                  <input matInput [formControl]="payloadKey" (input)="keyRequired = false" />
                </mat-form-field>
              </div>
              <div class="col-3 pl-0">
                <div class="d-flex align-items-end justify-content-between mt-2">
                  <div class="d-flex align-items-center">
                    <button mat-raised-button class="btn btn-primary" (click)="addItem($event)">
                      {{ index ? 'Update' : 'Add Key' }}
                    </button>
                    <button
                      *ngIf="index"
                      mat-raised-button
                      class="btn btn-light ml-4"
                      (click)="cancelItemUpdate($event)"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <ng-container>
              <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
                <div class="col-10">Key</div>
                <div class="col-2">Actions</div>
              </div>
              <div *ngIf="!payloadKeysList?.length" class="font-weight-bold text-center w-100">
                There are no keys added!
              </div>
              <div style="overflow-y: scroll; max-height: 200px" *ngIf="payloadKeysList?.length">
                <div
                  *ngFor="let key of payloadKeysList; let i = index"
                  class="row border-bottom m-0 mb-2 p-2 w-100"
                >
                  <div class="col-10">{{ key }}</div>
                  <div class="col-2">
                    <button
                      class="btn btn-icon btn-sm btn-light btn-hover-primary mr-1"
                      [matTooltip]="'TABLE.UPDATE' | translate"
                      (click)="updateItem($event, i)"
                    >
                      <span
                        inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                        class="svg-icon svg-icon-md svg-icon-primary"
                      ></span>
                    </button>
                    <button
                      class="btn btn-icon btn-sm btn-light btn-hover-danger"
                      [matTooltip]="'TABLE.DELETE' | translate"
                      (click)="deleteItem($event, i)"
                    >
                      <span
                        inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                        class="svg-icon svg-icon-md svg-icon-danger"
                      ></span>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          matTooltip="Save"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
